import { gql } from '@apollo/client';

export const CREATE_MAILING_LIST_SUBSCRIPTION = gql`
  mutation CreateMailingListSubscription($input: CreateMailingListSubscriptionInput!) {
    createMailingListSubscription(input: $input) {
      mailingListSubscription {
        id
        email
      }
      errors
    }
  }
`;
